export default {
  init() {
    // JavaScript to be fired on the home page
    function getStandings(id='8'){
      var data = {
        'action': 'render_standing',
        'id' : id,
        'security': window.ajax_object.security,
      };
      jQuery.get(window.ajax_object.ajaxurl,data, function( res ) {
        if(res.success){
          jQuery('#ranks').html(res.data);
          jQuery('#sel_giai_dau_liv').show();
        }
      });
    }
    jQuery('#sel_giai_dau_liv a').click(function() {
      var id = $(this).data('key');
      jQuery('#sel_giai_dau_liv a').removeClass('active');
      $(this).addClass('active');
      getStandings(id);
      return false;
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-standing.js